import Button from '@mui/material/Button';
import { Translate } from '@shared/translation';
import type { TimeZone } from '@shared/utils/date';
import type { DateRange, Preset } from '../types';

interface PresetButtonProps {
  active: boolean;
  onClick: (value: DateRange) => void;
  preset: Preset;
  timeZone?: TimeZone;
}

export function PresetButton({
  active,
  onClick,
  preset,
  timeZone,
}: PresetButtonProps) {
  return (
    <Button
      color="inherit"
      disabled={active}
      onClick={() => onClick(preset.createRange({ timeZone }))}
      size="small"
      type="button"
      variant="outlined"
      sx={(theme) => {
        const activeBackground = theme.palette.background.inverted;

        return {
          borderRadius: 16,
          fontSize: 11,
          fontWeight: 400,
          lineHeight: 'normal',
          minHeight: 26,
          padding: theme.spacing(0, 1),
          textTransform: 'none',
          ...(active
            ? {
                '&.Mui-disabled': {
                  backgroundColor: activeBackground,
                  color: theme.palette.getContrastText(activeBackground),
                  opacity: 1,
                },
              }
            : {}),
        };
      }}
    >
      <Translate text={preset.label} values={preset.values} />
    </Button>
  );
}
